import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { getSelf } from '../Header/HeaderActions';

import { getAllCapacities, getTerminals } from './DashboardActions';
import Dashboard from '../../views/Dashboard/Dashboard';
import { getSettings } from '../Settings/SettingsActions';
import { toast } from 'react-toastify';


class DashboardContainer extends React.Component {
  constructor(props) {
    super(props);
    let date = moment();

    //let start = date;
    //let end = date.add(1, "day");

    //  let today = date.format('YYYY-MM-DD');
    this.state = {
      date: date,
      start: date.format('YYYY-MM-DD'),
      end: date.format('YYYY-MM-DD')
    };

    this.onDateChange = this.onDateChange.bind(this);
  }

  componentDidMount() {
    let { self, dispatchGetSettings, dispatchGetSelf, dispatchGetAllCapacities } = this.props;
    let { start, end } = this.state;
    let paramaters = {
      start,
      end
    };
    dispatchGetAllCapacities(paramaters);
    dispatchGetSelf((err, result) => {
      if(err){
        toast.error(err.message);
      }else{
      dispatchGetSettings({
        orgId: result.organization.parentId
      });
    }
    });
  }


  onDateChange(date) {
    this.setState({ date: moment(date) }, () => {

      const { dispatchGetAllCapacities } = this.props;
      let startString =  moment(date).format('YYYY-MM-DD');
      let endString =  moment(date).format('YYYY-MM-DD');

      let paramaters = {
        start: startString,
        end: endString
      };

      dispatchGetAllCapacities(paramaters, (err, data) => {
        if (!err) {
          this.setState({
            start: startString,
            end: endString
          });
        }
      });
    });
  }

  render() {
    let { capacity, settings } = this.props;
    let { start, end, date } = this.state;

    let jscapacity = capacity.toJS();
    delete jscapacity.isFetching;
    let capacityEntries = Object.entries(jscapacity);

    return <Dashboard settings={settings} date={date} onDateChange={this.onDateChange} start={start} end={end} capacityEntries={capacityEntries} />;


  }
}

const mapStateToProps = (state) => ({
  self: state.self,
  settings: state.settings,
  terminals: state.business.terminals.get('data') || [],
  capacity: state.business.capacity || {}
});

const mapDisptatchToProps = (dispatch) => ({
  dispatchGetSelf: (cb) => dispatch(getSelf(cb)),
  dispatchGetSettings: (parameters, cb) => dispatch(getSettings(parameters, cb)),
  dispatchGetTerminals: (cb) => dispatch(getTerminals(cb)),
  dispatchGetAllCapacities: (param, cb) => dispatch(getAllCapacities(param, cb))
});

export default connect(mapStateToProps, mapDisptatchToProps)(DashboardContainer);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardContainer.js